// Brand assets (logo font and icon) are loaded before the first paint, so the logo never appears
// in a fallback font or without its icon and then jumps. A timeout keeps a slow network from blocking the app.
const LOGO_FILES = ["logo.svg", "logo-dark.svg"];
const MAX_WAIT_MS = 2500;

export const logoSrc = (theme) => `${process.env.PUBLIC_URL}/${theme === "dark" ? "logo-dark.svg" : "logo.svg"}`;

function loadImage(name) {
  return new Promise((resolve) => {
    const image = new Image();
    image.onload = () => (image.decode ? image.decode().catch(() => {}) : Promise.resolve()).then(resolve);
    image.onerror = resolve;
    image.src = `${process.env.PUBLIC_URL}/${name}`;
  });
}

let ready = null;

export function brandReady() {
  if (!ready) {
    const font = typeof document !== "undefined" && document.fonts
      ? document.fonts.load('30px "Minder"', "Tracker").catch(() => {})
      : Promise.resolve();
    ready = Promise.race([
      Promise.all([font, ...LOGO_FILES.map(loadImage)]),
      new Promise((resolve) => setTimeout(resolve, MAX_WAIT_MS)),
    ]);
  }
  return ready;
}
